import { IOpenedFormHistoryInfo } from "@multiweb/types/contracts";
import { Event } from "../../../../Global/Base/Events";
import { IWindowable } from "../UIManagerInterfaces";

/**
 * Umožňuje spravovat - ukládat a načítat - data historie otevřených formulářů.
 * @includeToDoc
 */
export interface IOpenedFormsHistoryManager {
    /**
     * Událost vyvolávaná při změně historie formulářů. Parametrem je nová historie.
     */
    readonly formHistoryUpdated: Event<IOpenedFormsHistoryManager, readonly Readonly<IOpenedFormHistoryInfo>[]>;

    /**
     * Přidání a mazání formuláře do/z historie. Historie je automaticky ihned uložena.
     * @param form Formulář k uložení do historie
     * @param menuItemId Id položky menu, ke které formulář patří
     */
    updateOpenedFormsHistory(form: IWindowable, menuItemId: number): Promise<void>;
    /**
     * Získá historii otevřených formulářů z úložiště.
     */
    getOpenedFormsHistory(): Promise<readonly IOpenedFormHistoryInfo[]>;
    /**
     * Označí ke smazání položku nebo profil patřící k formuláři `form`.
     * Pokud je definováno `menuItemId`, označí ke smazání položku s tímto id.
     * Pokud je definováno `profileId`, označí ke smazání profil s tímto id.
     * @param form Formulář jehož položky budeme z historie odstraňovat.
     * @param menuItemId Id položky menu.
     * @param profileId Id profilu.
     * @return Promise s hodnotou `true` pokud se odstranila nějaká položka, jinak s hodnotou `false`.
     */
    markOpenedFormsHistoryItemToBeRemovedOnFormClose(form: IWindowable, menuItemId?: number, profileId?: number): boolean;
}

export class IOpenedFormsHistoryManager {
    private static _properties: (keyof IOpenedFormsHistoryManager)[] = ["formHistoryUpdated"];
    private static _methods: (keyof IOpenedFormsHistoryManager)[] = ["updateOpenedFormsHistory", "getOpenedFormsHistory"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null
            && !this._properties.some((value) => !Reflect.has(instance, value))
            && !this._methods.some(value => typeof instance[value] !== "function");
    }
}
